'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var EmailRead = function EmailRead(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React__default["default"].createElement("g", {
    transform: "translate(-705.000000, -91.000000)"
  }, React__default["default"].createElement("g", {
    transform: "translate(0.000000, 65.000000)"
  }, React__default["default"].createElement("g", {
    transform: "translate(548.000000, 16.000000)"
  }, React__default["default"].createElement("g", {
    transform: "translate(148.000000, 0.000000)"
  }, React__default["default"].createElement("g", {
    transform: "translate(8.000000, 8.000000)"
  }, React__default["default"].createElement("path", {
    d: "M18,12 C20.76,12 23,14.24 23,17 C23,19.76 20.76,22 18,22 C15.24,22 13,19.76 13,17 C13,14.24 15.24,12 18,12 Z M18,13 C15.79,13 14,14.79 14,17 C14,19.21 15.79,21 18,21 C20.21,21 22,19.21 22,17 C22,14.79 20.21,13 18,13 Z M20.295,14.79 L21,15.5 L17,19.5 L14.5,17 L15.205,16.295 L17,18.085 L20.295,14.79 Z M19,2 C20.05,2 20.9177686,2.82004132 20.9944872,3.85130541 L21,4 L21.0012092,11.0225923 C19.9906579,10.3752958 18.7891565,10 17.5,10 C13.9101491,10 11,12.9101491 11,16.5 C11,17.0165691 11.0602586,17.519064 11.1741301,18.000839 L3,18 C1.95,18 1.0822314,17.1799587 1.00551277,16.1486946 L1,16 L1.01,4 C1.01,2.95 1.82092975,2.0822314 2.85136551,2.00551277 L3,2 L19,2 Z M19,4 L11,9 L3,4 L3,6 L11,11 L19,6 L19,4 Z"
  }))))))));
};

var EmailRead$1 = iconStyles()(EmailRead);

module.exports = EmailRead$1;
